import { render, staticRenderFns } from "./TournamentForm.vue?vue&type=template&id=22234850&scoped=true&"
import script from "./TournamentForm.vue?vue&type=script&lang=js&"
export * from "./TournamentForm.vue?vue&type=script&lang=js&"
import style0 from "./TournamentForm.vue?vue&type=style&index=0&id=22234850&prod&lang=css&"
import style1 from "./TournamentForm.vue?vue&type=style&index=1&id=22234850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22234850",
  null
  
)

export default component.exports